import * as MessageActions from '../../common/messageBox/actions/actions';
import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const processWarrantyExcelList = (warrantyExcelList) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/warranties/excel',
      'authenticated': true,
      'types': [
        ActionTypes.PROCESSING_WARRANTY_EXCEL_LIST,
        ActionTypes.PROCESSED_WARRANTY_EXCEL_LIST,
        [
          ActionTypes.PROCESSED_WARRANTY_EXCEL_LIST_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'POST',
      'contentType': 'application/json',
      'data': {warrantyExcelList},
    })
  );
};

export const addWarrantyExcelList = (warrantyExcelList, create) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/warranties/excel',
      'authenticated': true,
      'types': [
        ActionTypes.ADDING_WARRANTY_EXCEL_LIST,
        [
          ActionTypes.ADDED_WARRANTY_EXCEL_LIST,
          MessageActions.addMessageBoxInfo(
            'Garantías actualizadas existosamente'
          ),
        ],
        [
          ActionTypes.ADDED_WARRANTY_EXCEL_LIST_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'POST',
      'contentType': 'application/json',
      'data': {warrantyExcelList, create},
    })
  );
};

export const clearWarrantyExcelList = () => ({
  'type': ActionTypes.CLEAR_WARRANTY_EXCEL_LIST,
});
